import React from 'react';
import { object, string, ref } from 'yup';
import omit from 'lodash/omit';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';

import { env } from '~/commons/config';
import _ from 'lodash';
import { part } from 'file-loader';
import FieldsCompPicker from './competition/FieldsCompPicker.jsx';

import FormResource from './FormResource.jsx';

const defaults = {
  active: true,
  username: '',
  password: '',
  name: { full: { en: '', zhhk: '' } },
};

const FormAdmin = ({ school, admin }) => {
  const isSchoolAdmin = env.user.roles.includes('schoolAdmin');
  const themeReports = env.competitions || {};
  return (
    <FormResource
      {...{
        defaults: {
          ...defaults,
          ...(school
            ? {
              school: school._id,
              roles: ['schoolAdmin'],
              competition: '',
              partiStudents: '',
              partiStudentsCount: 0,
            }
            : { roles: ['admin'] }),
          ...(isSchoolAdmin ? { confirmPassword: '' } : ''),
        },
        schema: object({
          username: string().required(),
          ...(!admin
            ? {
              password: string().required(),
            }
            : {}),
          ...(isSchoolAdmin
            ? {
              confirmPassword: string().when('password', {
                is: (p) => p,
                then: (s) => s
                  .required()
                  .oneOf([ref('password')], 'Password does not match'),
              }),
            }
            : {}),
        }),
        stored: admin,
        api: 'api/core/users/admins',
        onSubmit: (v) => {
          if (v.partiStudents) {
            v.partiStudents = _.split(v.partiStudents, ',')
              .map((s) => s.trim())
              .join(',');
          }
          return omit(v, !v.password ? 'password' : null);
        },
      }}
    >
      {({ values }) => {
        console.log({ values });
        const isThemeReports = values.competition === themeReports._id;
        return (
          <>
            {env.user.roles.includes('admin') && (
              <div className="form-group">
                <label>Active</label>
                <FormCheckGroup
                  name="active"
                  type="checkbox"
                  label=""
                  asSwitch
                />
              </div>
            )}
            {school && <FieldsCompPicker />}
            <FormGroup name="username" disabled={isSchoolAdmin} />
            <div className="form-row">
              <div className="col">
                <FormGroup name="name.full.zhhk" label="Name (Chinese)" />
              </div>
              <div className="col">
                <FormGroup name="name.full.en" label="Name (English)" />
              </div>
            </div>
            <div className="form-row">
              <div className="col">
                <FormGroup
                  name="password"
                  type="password"
                  placeholder={
                    admin ? 'Leave this blank to keep the stored password' : ''
                  }
                />
              </div>
              {isSchoolAdmin && (
                <div className="col">
                  <FormGroup
                    name="confirmPassword"
                    type="password"
                    placeholder={
                      admin
                        ? 'Leave this blank to keep the stored password'
                        : ''
                    }
                  />
                </div>
              )}
            </div>

            {school && isThemeReports && (
              <>

                <div className="form-row">
                  <div className="col">
                    <FormGroup
                      name="partiStudents"
                      type="text"
                      label="參賽學生(comma separated)"
                    />
                  </div>
                  <div className="col">
                    <FormGroup
                      name="partiStudentsCount"
                      type="number"
                      label="團隊人數"
                    />
                  </div>
                </div>
              </>
            )}
          </>
        );
      }}
    </FormResource>
  );
};

export default FormAdmin;
